var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classes},[_c('v-alert',_vm._g(_vm._b({attrs:{"border":"left","colored-border":"","type":"info"}},'v-alert',_vm.$attrs,false),_vm.$listeners),[_vm._t("alert_text"),_vm._t("edit_alert_text_second")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }